import { Box } from "@chakra-ui/react";
import { AgentTaskProgress } from "@fencyai/react";
import type { AgentTaskProgressProps } from "@fencyai/react";
import { HIDE_AGENT_TASK_COPY_ID_SX } from "./agentTaskProgressSx";

type Props = Omit<AgentTaskProgressProps, "language">;

// The two workarounds every <AgentTaskProgress> render site needs, kept together so neither is
// forgotten: pins the built-in strings to Norwegian (AgentTaskLanguage supports 'en' | 'no' — the
// package ships a full 'no' translation table, so this alone localizes "Processing task" etc. with no
// override needed) and hides the unused "copy task id" control (see agentTaskProgressSx.ts).
export const LocalizedAgentTaskProgress = (props: Props) => (
  <Box sx={HIDE_AGENT_TASK_COPY_ID_SX}>
    <AgentTaskProgress language="no" {...props} />
  </Box>
);
